package com.macrofocus.eflux.ui

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.diagram.DiagramType
import com.macrofocus.eflux.ui.mui.themes.ThemeModule
import com.macrofocus.eflux.ui.mui.themes.Themes
import com.macrofocus.eflux.ui.mui.utilities.BrowserAppPreference
import i18next.useTranslation
import js.coroutines.awaitCancellation
import kotlinx.browser.localStorage
import mui.material.useMediaQuery
import react.*

val AppPreferenceDispatcherContext = createContext<BrowserAppPreference>()

val AppContextProvider = FC<AppFrameContainerProps> { props ->
//    val (koinApp, appScope) = use(KoinContext)

    val (appPreference, setAppPreference) = useState<BrowserAppPreference>()
//    val (viewModel, setViewModel) = useState<JsAuthenticationViewModel>()
    val (_, i18n) = useTranslation()

    useEffectOnce {
//        val module = module {
//            scope(named(APP_FRAME_SCOPE_ID)) {
//                scoped { JsAuthenticationViewModel(get(), appScope) }
//            }
//        }
//
//        koinApp.modules(module)
//        koinApp.koin.createScope(APP_FRAME_SCOPE_ID, named(APP_FRAME_SCOPE_ID))

        setAppPreference(BrowserAppPreference(localStorage, i18n))
//        setAppPreference(value = koinApp.koin.get())
//        setViewModel(value = koinApp.koin.getScope(APP_FRAME_SCOPE_ID).get())
//
        awaitCancellation {
//            koinApp.unloadModules(module)
//            koinApp.koin.deleteScope(APP_FRAME_SCOPE_ID)
        }
    }

    println("AppPreference: $appPreference")
    appPreference ?: return@FC
//    viewModel ?: return@fc
    println("AppPreference: ${appPreference.lang} ${appPreference.themeType}")

    AppPreferenceDispatcherContext.Provider {
        value = appPreference

//        AuthenticationDispatcherContext.Provider {
//            attrs.value = viewModel

            AppFrameContainer {
                this.dataLoader = props.dataLoader
                this.showTableProperty = props.showTableProperty
                this.diagramTypeProperty = props.diagramTypeProperty

                +props.children
            }
//        }
    }
}

private val AppFrameContainer = FC<AppFrameContainerProps> { props ->
    val preferredType = if (useMediaQuery("(prefers-color-scheme: dark)")) PaletteType.dark else PaletteType.light
//    val history = useLocation()

    val appPreference = use(AppPreferenceDispatcherContext)!!

    val (appPreferenceState, setAppPreferenceState) = useState(BrowserAppPreference.State(appPreference))
    println("appPreferenceState1 $appPreferenceState")

    useEffectOnce {
        val themeType = appPreference.themeType ?: return@useEffectOnce

        setAppPreferenceState(appPreferenceState.copy(themeType = themeType))
    }
    println("appPreferenceState2 $appPreferenceState")

    useEffect(preferredType) {
        if (appPreference.themeType != null) return@useEffect

        setAppPreferenceState(appPreferenceState.copy(themeType = preferredType))
    }
    println("appPreferenceState3 $appPreferenceState")
//    useEffect(lang.code != appPreference.lang.code) {
//        appPreference.setLanguage(lang)
//
//        setAppPreferenceState(appPreferenceState.copy(lang = lang))
//    }

    println("appPreferenceState4 $appPreferenceState")
    useEffect(appPreferenceState) { appPreference.setThemeType(appPreferenceState.themeType) }

    println("appPreferenceState5 $appPreferenceState")
    fun toggleTheme() {
        setAppPreferenceState(appPreferenceState.copy(
            themeType = if (appPreferenceState.themeType == PaletteType.light)
                PaletteType.dark
            else
                PaletteType.light
        ))
    }

//    val tab = SearchByTab.findByQuery(useQuery().get("by"))

//    val (_, appScope) = use(KoinContext)
//    val viewModel = use(AuthenticationDispatcherContext)

    val (openDrawer, setOpenDrawer) = useState(false)
//    val (currentUser, setCurrentUser) = useState<CurrentUser?>(null)

//    useEffectOnce {
//        viewModel.uiModel.onEach {
//            setCurrentUser(it.currentUser)
//        }.launchIn(appScope)
//
//        viewModel.subscribe()
//    }

    fun closeMenu() { setOpenDrawer(false) }
    fun toggleMenu() { setOpenDrawer(!openDrawer) }

    val darkTheme = Themes.DarkDiviso //createTheme(PaletteType.dark)
    val lightTheme = Themes.LightDiviso // createTheme(PaletteType.light)

    val currentTheme = if (appPreferenceState.themeType == PaletteType.dark) darkTheme else lightTheme

    ThemeModule {
//        this.theme = currentTheme

//        attrs.paletteType = appPreferenceState.themeType

//        AuthenticationProviderContext.Provider {
//            attrs.value = currentUser

        +props.children
//        }
    }
}

external interface AppFrameContainerProps : PropsWithChildren {
    var dataLoader: DataLoader
    var diagramTypeProperty: MutableProperty<DiagramType>
    var showTableProperty: MutableProperty<Boolean>
}